import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHSymbol, HTHSymbolStates} from "../symbols/HTHSymbol";
import {HTHAvalancheReelModel} from "../reels/HTHAvalancheReelModel";

export class HTHAvaSplitPresentation implements SimplePresentation {

    constructor() {
    }

    shouldRun(): boolean {
        return HTH.model.gameData.increaseMultiplierCoordinates.length > 0 && HTH.model.isNextAvalanche && !HTH.model.isGodModeMaxWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        const symPos: {x:number,y:number}[] = HTH.model.gameData.increaseMultiplierCoordinates;

        symPos.forEach((value: {x:number,y:number}) => {
            const sym: HTHSymbol = HTH.reelArea.getSymbol([value.x, value.y]);
            sym.avaSplitTarget = true;
        });

   /*     HTH.reelArea.allReels.forEach((reel: HTHAvalancheReelModel, reelID: number) => {
            tl.add(reel.reelView.avasplitEffect(), 0.05);
        });*/

        tl.to(this, {duration: 0.001});
    }

}